import React, {useState, useRef, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

const LANGUAGES = [
    {code: 'en',    native: 'English'},
    {code: 'fi',    native: 'Suomi'},
    {code: 'es',    native: 'Español'},
    {code: 'pt-BR', native: 'Português'},
    {code: 'de',    native: 'Deutsch'},
    {code: 'hi',    native: 'हिन्दी'},
];

export default function LangSelector({compact}) {
    const {i18n} = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const close = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('pointerdown', close);
        return () => document.removeEventListener('pointerdown', close);
    }, [open]);

    const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

    const btnStyle = {
        display: 'flex', alignItems: 'center', gap: 5,
        background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.25)',
        borderRadius: 6, padding: compact ? '2px 6px' : '4px 10px',
        color: '#eee', cursor: 'pointer',
        fontSize: compact ? 11 : 13, fontFamily: 'sans-serif',
        lineHeight: 1, whiteSpace: 'nowrap',
    };

    return (
        <div ref={ref} style={{position: 'relative', zIndex: 100}}>
            <button style={btnStyle} onClick={() => setOpen(o => !o)}>
                <span style={{fontSize: compact ? 14 : 16}}>🌐</span>
                <span>{current.native}</span>
            </button>
            {open && (
                <div style={{
                    position: 'absolute', top: '110%', right: 0,
                    background: '#23233a', border: '1px solid #555',
                    borderRadius: 8, padding: 4, minWidth: 120,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
                }}>
                    {LANGUAGES.map(lang => (
                        <button
                            key={lang.code}
                            onClick={() => { i18n.changeLanguage(lang.code); setOpen(false); }}
                            style={{
                                display: 'flex', alignItems: 'center', gap: 8,
                                width: '100%', padding: '6px 10px',
                                background: lang.code === i18n.language ? 'rgba(255,255,255,0.15)' : 'transparent',
                                border: 'none', borderRadius: 6,
                                color: '#eee', cursor: 'pointer',
                                fontSize: 13, fontFamily: 'sans-serif',
                            }}
                        >
                            <span>{lang.native}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
